var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", {
        attrs: {
          id: "wheelofnames_siderail_left",
          "data-freestar-ad": "__336x280"
        }
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "Freestar_Video_Container_Fixed" } }),
      _vm._v(" "),
      _c("button", { attrs: { id: "pmLink" } }, [_vm._v("Privacy Manager")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }